export class LeadWorkspaceApi {
  #crmHttp;

  #skynetHttp;

  #loansHttp;

  constructor(crmHttp, skynetHttp, loansHttp) {
    this.#crmHttp = crmHttp;
    this.#skynetHttp = skynetHttp;
    this.#loansHttp = loansHttp;
  }

  async getApplicationContacts({ applicationId }) {
    return this.#crmHttp.get(`/api/applications/${applicationId}/contacts`);
  }

  // Latest saved Pricing Workbench quote for a lead (crm.ApplicationPricingQuotes, DEV-6277). 204
  // when none saved yet — the lead's Quoted Scenario card renders an empty state, not an error.
  async getApplicationPricingQuote({ applicationId }) {
    return this.#crmHttp.get(`/api/applications/${applicationId}/pricing-quote`);
  }

  // Every saved quote for a lead, newest first (LEN-87). The scenario table is append-only, so this
  // is the history behind the latest quote — always a 200 array ([] when never priced). The first
  // element equals getApplicationPricingQuote's latest.
  async getApplicationPricingQuoteHistory({ applicationId }) {
    return this.#crmHttp.get(`/api/applications/${applicationId}/pricing-quote/history`);
  }

  // Append the priced scenario onto a lead (append-only; ApplicationId/CompanyId/PricedAt are set
  // server-side). Body = ApplicationPricingQuoteDto. Write is gated on crm.contacts.manage.
  async saveApplicationPricingQuote({ applicationId, quote }) {
    return this.#crmHttp.put(`/api/applications/${applicationId}/pricing-quote`, quote);
  }

  async getLeadScore({ contactId }) {
    return this.#crmHttp.get(`/api/contacts/${contactId}/score`);
  }

  async recomputeLeadScore({ contactId }) {
    return this.#crmHttp.post(`/api/contacts/${contactId}/score`);
  }

  async associateContact({ contactId, applicationId, role }) {
    return this.#crmHttp.post(`/api/contacts/${contactId}/links/applications`, {
      applicationId,
      role,
    });
  }

  async changeContactRole({ contactId, applicationId, role }) {
    return this.#crmHttp.put(
      `/api/contacts/${contactId}/links/applications/${applicationId}/role`,
      { role },
    );
  }

  async makeContactPrimary({ contactId, applicationId }) {
    return this.#crmHttp.post(
      `/api/contacts/${contactId}/links/applications/${applicationId}/make-primary`,
    );
  }

  async unlinkContact({ contactId, applicationId }) {
    return this.#crmHttp.delete(`/api/contacts/${contactId}/links/applications/${applicationId}`);
  }

  async captureLeadSourceCandidate({ rawLabel }) {
    return this.#skynetHttp.post('/LeadSourceCandidate', { rawLabel });
  }

  async getIndicativeQuote({ scenarioBody }) {
    return this.#loansHttp.post('/api/leads/indicative-quote/internal', scenarioBody);
  }
}
